import React,{useState,useRef, useEffect} from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useParams } from 'react-router-dom';
import { Tabs, Tab, Box, Grid, Typography, Stack, Button, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Checkbox, ListItemText,Dialog, DialogTitle, DialogContent, DialogActions,DialogContentText} from '@mui/material';
import Chip from '@mui/material/Chip';
import ConfirmDialog from '../ConfirmDialog';
import { useSnackbar } from '../SnackBar';
import EditDialogBodyType from '../EditDialog/EditDialogBodyType';
const CoupansEditData=()=>{
    const userType=localStorage.getItem('userType');
    const { showSnackbar } = useSnackbar();
    const { id, edit } = useParams();
    const [loading, setLoading] = useState(true); 
    const didFetch = useRef(false); 
    const [coupansData, setCoupanData] = useState(null); 
    const { GetCoupansById } = useServiceContext(); 
    const [approved, setApproved] = useState(false);
    const [open, setOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingStatus, setPendingStatus] = useState(null);
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState('');
    const [confirmOpen1, setConfirmOpen1] = useState(false); 
    const [selectedValues, setSelectedValues] = useState([]);

    const {FetchBranches} = useBranchContext();
    const {GetPartnerServices} = useServiceContext();
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedServices, setSelectedservices] = useState([]);
    const [selectedServicesone, setSelectedservicesone] = useState([]);
    const [services, setServices] = React.useState([]);
    const [branches, setBranch] = React.useState([]);
    const [availCounts, setAvailCounts] = useState({});


    const getData = async () => { 
        try { 
           const data1= await FetchBranches();
            setBranch(await FetchBranches());
            setServices(await GetPartnerServices());
            const data = await GetCoupansById(id); // Pass the id to GetCoupansById 
            setCoupanData(data); 
            console.log(data);
            setLoading(false); 
            debugger
            if(data){
                const initialSelectedBranches = data.branchesAvailable.map(branch => branch.branchId); 
                setSelectedBranches(initialSelectedBranches); 
                const initialSelectedServices = data.serviceOffered.map(service => service.serviceId); 
                setSelectedservices(initialSelectedServices);
                const initialSelectedServiceone=data.servicesApplicable.map(service1=>service1.serviceId);
                setSelectedservicesone(initialSelectedServiceone);
                const count={};
                const numberOfTimes={};
                data.servicesApplicable?.forEach(service=>{
                  count[service.serviceId]=service.availCount;
                  numberOfTimes[service.serviceId]=service.availCount  

                });
                setAvailCounts(count);
                setNumberOfTimes(numberOfTimes);
                
            }
        } catch (error) { 
            console.error('Error fetching data:', error); 
            setLoading(false); } 
            
        }; 
        useEffect(() => { 
            if (!didFetch.current) { 
                getData(); 
                didFetch.current = true; 
        }},[]);
        const handleChange = (event) => { 
            if(event.target.name==='branch'){
                const { target: { value }, } = event; 
                setSelectedBranches( typeof value === 'string' ? value.split(',') : value, ); 
            }
            if(event.target.name==='service'){
                const { target: { value }, } = event; 
                setSelectedservices( typeof value === 'string' ? value.split(',') : value, ); 
            }
            if(event.target.name==='service1'){
                const { target: { value }, } = event; 
                setSelectedservicesone( typeof value === 'string' ? value.split(',') : value, ); 
            }
        };

         const[serviceNumberOfTimes,setNumberOfTimes]=useState({});
            const handleNumberOfTimes = (id, count) => {
                const serviceId = parseInt(id, 10);
                const availCount = parseInt(count, 10);
              
                // Update the state with the new object
                setNumberOfTimes((prevState) => ({
                    ...prevState,
                    [serviceId]: availCount,
                }));
              };


        const handleActive=(event)=>{
            const isActive=event.target.checked;
            setPendingStatus(isActive);
            setConfirmOpen1(true); 
        } 
        const handleApproveClick = () => {
                setOpen(true); // Open the confirmation dialog
        };
        const handleConfirmStatusChange = async () => {
            const value = pendingStatus ? 'true' : 'false';
            const id = coupansData.id;
    
            coupansData.isActive = pendingStatus; // Update the branch status locally
            //await ActivateBranchById(branchId, value); // Call the API
            showSnackbar(`Branch ${pendingStatus ? 'Activated' : 'Deactivated'} Successfully`);
            setConfirmOpen(false); // Close the dialog
        };
        const handleDeleteClick = () => {
            setConfirmOpen(true); // Open the confirmation dialog
          };
        const handleConfirmDelete = async () => {
            setConfirmOpen(false); // Close the confirmation dialog
            if (coupansData.id) {
              debugger;
              //deleteBranch(coupansData.id);
              showSnackbar('Branch deleted successfully', 'success');
              //navigate('/newbranch');// Delete the selected brand
            }
        
          };
          const handleActiveDeactive = async () => {
            setConfirmOpen1(false); // Close the confirmation dialog
            if (coupansData.id) {
              debugger;
              //deleteBranch(branchData.id);
              showSnackbar('Branch status changed successfully', 'success');
              //navigate('/newbranch');// Delete the selected brand
            }
        
        };
        const handleClose = () => {
            setOpen(false); // Close the confirmation dialog 
        };
        const handleConfirm = async () => {
            try {
                //await ApproveBranchById(branchData);
                //branchData.isApproved = true;
    
                showSnackbar('Branch approved successfully');
                setApproved(true);
                setOpen(false); // Close the dialog after successful confirmation
            } catch (error) {
                console.error('Error approving branch:', error);
            }
        };
        const handleConfirmClose = () => {
            setConfirmOpen(false); // Close the confirmation dialog
        };
        const formRef=useRef([]);
        const handleClick=()=>{
            const formElements=formRef.current.element;
            for(let elements of formElements){
                if(elements.tagNmae=='INPUT' && (elements.type!='submit'||elements.type!='button')){
                    if(elements.value===""){
                        elements.style.borderColor='red';
                    }else{
                        elements.style.borderColor='';
                    }
                }
            }
        }
        const emptyFieldCheck=(e)=>{
            if(e.target.value===""){
                e.target.style.borderColor='';
            }else{
                e.target.style.borderColor='';
            }
        }
        const UpdateCoupan=async()=>{
            //const coupannameRef=useRef("");
            //const validityRef=useRef("");
            // if(){

            // }else{

            // }


        }

     return(
        <div>{didFetch.current && !loading && coupansData && (<main id="main" className="main">
            <div className="pagetitle">

                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/CoupanList">Home</a></li>
                       
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="card">
                        <div className="card-body"><h4 className="mb-3">Coupan Edit Details</h4>

                            <div className="row">
                                <nav className="navbar navbar-expand-lg navbar-light">
                                    <div className="container-fluid">
                                    
                                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </nav>

                                <div className="col-lg-6">
                                    <form ref={formRef}>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Name</label>
                                                <div className="col-sm-8">
                                                    <input type="text" className="form-control" name="name" value={coupansData.name} />
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Validity</label>
                                                <div className="col-sm-8">
                                                    <input type="text" className="form-control" name="Validity" value={coupansData.validity} />
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-3 col-form-label">ServicesOffered</label>
                                        <div className="col-sm-8">
                                        <FormControl fullWidth sx={{ width: '300px' }}>
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            multiple
                                                            value={selectedServices}
                                                            name="service"
                                                            onChange={handleChange}
                                                            renderValue={(selected) => (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                    {selected.map((value) => {
                                                                        // Find the name corresponding to the selected ID
                                                                        const selectedItem = services.find(item => item.id === value);
                                                                        return (
                                                                            <Chip
                                                                                key={value}
                                                                                label={selectedItem?.name}

                                                                            />
                                                                        );
                                                                    })}
                                                                </Box>
                                                            )}

                                                            sx={{
                                                                width: "300px",           // Adjust width as needed
                                                                // Rounded corners
                                                                "& .MuiOutlinedInput-root": {

                                                                },
                                                                "& .MuiSelect-select": {
                                                                    padding: "8px 12px",     // Adjust padding
                                                                },
                                                            }}
                                                        >
                                                        {(services || []).map((service) => ( 
                                                            <MenuItem key={service.id} value={service.id}> 
                                                                <Checkbox checked={selectedServices.includes(service.id)} /> 
                                                                <ListItemText primary={service.name} /> 
                                                            </MenuItem> ))}
                                                          
                                                        </Select>
                                                    </FormControl>
                                                    </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-3 col-form-label">BranchesAvailable</label>
                                        <div className="col-sm-8">
                                        <FormControl fullWidth sx={{ width: '300px' }}>
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            multiple
                                                            value={selectedBranches}
                                                            name="branch"
                                                            onChange={handleChange}
                                                            renderValue={(selected) => (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                    {selected.map((value) => {
                                                                        // Find the name corresponding to the selected ID

                                                                        const selectedItem = branches.find(item => item.id === value);
                                                                        return (
                                                                            <Chip
                                                                                key={value}
                                                                                label={selectedItem?.name}

                                                                            />
                                                                        );
                                                                    })}
                                                                </Box>
                                                            )}

                                                            sx={{
                                                                width: "300px",           // Adjust width as needed
                                                                // Rounded corners
                                                                "& .MuiOutlinedInput-root": {

                                                                },
                                                                "& .MuiSelect-select": {
                                                                    padding: "8px 12px",     // Adjust padding
                                                                },
                                                            }}
                                                        >
                                                           {(branches || []).map((branch) => ( 
                                                            <MenuItem key={branch.id} value={branch.id}> 
                                                                <Checkbox checked={selectedBranches.includes(branch.id)} /> 
                                                                <ListItemText primary={branch.name} /> 
                                                            </MenuItem> ))}
                                                        </Select>
                                                    </FormControl>
                                                    </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-3 col-form-label">ServicesApplicable</label>
                                        <div className="col-sm-8">
                                        <FormControl fullWidth sx={{ width: '300px' }}>
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            multiple
                                                            value={selectedServicesone}
                                                            name="service1"
                                                            onChange={handleChange}


                                                            renderValue={(selected) => (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                    {selected.map((value) => {
                                                                        // Find the name corresponding to the selected ID

                                                                        const selectedItem = services.find(item => item.id === value);
                                                                        return (
                                                                            <Chip
                                                                                key={value}
                                                                                label={selectedItem?.name}

                                                                            />
                                                                        );
                                                                    })}
                                                                </Box>
                                                            )}

                                                            sx={{
                                                                width: "300px",           // Adjust width as needed
                                                                // Rounded corners
                                                                "& .MuiOutlinedInput-root": {

                                                                },
                                                                "& .MuiSelect-select": {
                                                                    padding: "8px 12px",     // Adjust padding
                                                                },
                                                            }}
                                                        >
                                                                {(services || []).map((service) => ( 
                                                            <MenuItem key={service.id} value={service.id}> 
                                                                <Checkbox checked={selectedServicesone.includes(service.id)} /> 
                                                                <ListItemText primary={service.name} /> 
                                                            </MenuItem> ))}
                                                           
                                                        </Select>
                                                    </FormControl>
                                                    </div>
                                                    { 
                                                        selectedServicesone.map((value)=>{
                                                            const selectedItem=services.find(item=>item.id===value);
                                                            return(
                                                            <Box key={value} sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                <Box sx={{ marginRight: '10px', width: '30%' }}> 
                                                                <InputLabel>{selectedItem?.name}</InputLabel> 
                                                            </Box>
                                                            <Box sx={{ width: '70%' }}> 
                                                                <input type="text" 
                                                                       className="form-control" 
                                                                       style={{ padding: '10px', height: '40px', width: '100%' }} 
                                                                       placeholder="Enter Number of Times" 
                                                                       value={serviceNumberOfTimes[value] || ''} 
                                                                       onChange={(e) => handleNumberOfTimes(value, e.target.value)}
                                                                /> 
                                                            </Box> 
                                                            </Box> 

                                                            

                                                        
                                                        
                                                            ); })

                                                    }
                                        </div>
                                    </div>
                                    <div className="card-body">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Coupan Status</label>
                                                <div className="col-sm-6">
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexSwitchCheckDefault"
                                                        checked={coupansData.isActive}
                                                        onChange={handleActive}
                                                        
                                                    />
                                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Active</label>
                                                
                                                </div>
                                            </div>
                                            {userType === 'ADMIN' && (
                                                <div className="col-sm-4">
                                                    {!approved && (
                                                        <button type="button" className="btn btn-primary" onClick={handleApproveClick}>
                                                            Approve
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                            {/* Confirmation Dialog */}
                                            <Dialog open={confirmOpen1} onClose={() => setConfirmOpen1(false)}>
                                                <DialogTitle>Confirm Status Change</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText>
                                                        Are you sure you want to {pendingStatus ? 'activate' : 'deactivate'} this branch?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setConfirmOpen1(false)} color="secondary">
                                                        Cancel
                                                    </Button>
                                                    <Button onClick={handleActiveDeactive} color="primary" autoFocus>
                                                        Confirm
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                            {/* Delete Button */}
                                                              
                                            
                                             {/* Confirmation Dialog */}
                                            <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                                                <DialogTitle>Confirm Deletion</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText>
                                                             Are you sure you want to delete this branch? This action cannot be undone.
                                                        </DialogContentText>
                                                        </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={handleConfirmClose} color="secondary">
                                                                    Cancel
                                                                </Button>
                                                                <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                                                    Confirm
                                                                    </Button>
                                                            </DialogActions>
                                            </Dialog>


                                                            <ConfirmDialog
                                                                open={open}
                                                                onClose={handleClose}
                                                                onConfirm={handleConfirm}
                                                                title="Confirm Approval"
                                                                content="Are you sure you want to approve this branch?"
                                                            />


                                                            <EditDialogBodyType
                                                                open={editOpen}
                                                                handleClose={() => setEditOpen(false)}
                                                                type={editType}
                                                                currentData={coupansData} // Pass branch data here if needed
                                                                handleSave={handleApproveClick}
                                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label"></label>
                                            <div className="col-sm-8">
                                                <button type="button" className="btn btn-primary" >Save</button>
                                            </div>
                                    </div>
                                </form>
                                </div>
                                </div> 
                                <div className="col-lg-6">
                                
                            </div>
                        </div> 
                    </div>
                </div>
            </section>
        </main>)}</div>



    );

}
export default CoupansEditData;